export let routes = [
  {
    path: '/x3-side-locate-address',
    name: 'x3-side-locate-address',
    component: () => import('@x3/js/side/location/locate-address.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];
  
export let api = {
  xsLocateAddress(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-locate-address',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
